/**
 * Parameters API Endpoints
 * Defines URL patterns for parameter/lookup data endpoints
 */

export const getCivilitiesUrl = () => `/parameters/civilities`;
export const getCountriesUrl = () => `/parameters/countries`;
export const getFamilyStatusUrl = () => `/parameters/family-status`;
export const getNationalitiesUrl = () => `/parameters/nationalities`;
export const getProductOptionsUrl = () => `/parameters/products`;
export const getProfessionCategoriesUrl = () =>
  `/parameters/profession-category`;
export const getProfessionsUrl = () => `/bank/professions`;
export const getAgenciesUrl = (size: number = 1000) =>
  `/bank/agences?size=${size}`;

export const getAccountPurposesUrl = () => `/parameters/account-purposes`;
export const getIncomeSourcesUrl = () => `/parameters/income-sources`;
export const getDistributionChannelsUrl = () =>
  `/parameters/distribution-channels`;
export const getSectorActivitiesUrl = () => `/parameters/sector-activities`;
